'use strict';

// EXPORTS //

module.exports = 4294967295; // 2**32 - 1



//////////////////
// WEBPACK FOOTER
// ./~/const-max-uint32/lib/index.js
// module id = 1700
// module chunks = 0